export namespace ProductStandardUtils {
  export type ProductStandardType = 'standard' | 'secondaryStandard'
  export type StandardLevelType = 'Primary' | 'Secondary'
  export type ProductStandard = {
    dataParamName?: ProductStandardType
    standardLevel: StandardLevelType
  }

  export const filterListByStandard = (item: ProductStandard) => {
    if (item?.dataParamName) {
      return item?.dataParamName === 'standard'
    }
    return item.standardLevel === 'Primary'
  }
  export const filterListBySecondaryStandard = (item: ProductStandard) => {
    if (item?.dataParamName) {
      return item?.dataParamName === 'secondaryStandard'
    }
    return item?.standardLevel === 'Secondary'
  }

  export const mapStandardByValue = (item: any) => {
    if ('value' in item) {
      // FIX: browser reload removes intended mapping
      return {
        ...item.value,
        code: item.value.uniqueIdentifier,
        name: item.value.standardLabel,
      }
    }

    return item
  }
}
